module.exports = __webpack_public_path__ + "media/images/countrysquared/hk-b613cfea942651f58ff1e21700a3cd6d.svg";